export default (theme) => ({
  drawer: {
    padding: 5,
    zIndex: 999999,
    width: 380,
  },
});
